export function CheckoutButtonController(cartService, cartDisplayService, $state, OUT_OF_STOCK_ERROR,
    cartStatusChannel, restaurantInfoFactory, $filter, ORDER_TYPES, utility, googleAnalyticsTrackingService, blockingCalloutService, paymentService) {
    'ngInject';
    let vm = this;
    vm.checkout = checkout;
    vm.canPlaceOrder = canPlaceOrder;
    vm.buttonText = buttonText;

    activate();

    ///---------

    function activate() {
        cartService.getCart()
            .then(() => vm.cartData = cartService.data);
        cartDisplayService.getDisplayData()
            .then(() => vm.cartDisplay = cartDisplayService.displayData);
        restaurantInfoFactory.getInfo(['deliveryInfo'])
            .then(data => vm.deliveryMinimum = data.deliveryInfo.deliveryMinimum);
    }

    function _cartAvailable() {
        return utility.isDefinedAndNotNull(vm.cartData) &&
              utility.isDefinedAndNotNull(vm.cartData.cart.items) &&
              utility.isDefinedAndNotNull(vm.cartData.cart.check) &&
              utility.isDefinedAndNotNull(vm.cartData.cart.check.totalAmount) &&
              utility.isDefinedAndNotNull(vm.deliveryMinimum) &&
              utility.isDefinedAndNotNull(vm.cartDisplay);
    }

    function _getPlaceOrderIssue() {
        let message = null;
        if (vm.cartData.cart.items.length === 0) {
            message = 'Add items to your cart to check out.';
        }
        else if (vm.cartDisplay && !vm.cartDisplay.restaurantAvailable)
            message = 'Online Ordering is currently not available.';
        else if (_shouldEnforceDeliveryMin() && _neededForDelivery() > 0)
            message = 'Please meet the delivery minimum to check out.';
        else if (!cartDisplayService.getDiningServiceSelected()) {
            message = 'Please select either takeout or delivery and an order time.';
        }
        else if (cartService.hasWarnings())
            message = vm.cartData.cart.warnings[0].message;
        return message;
    }

    function canPlaceOrder() {

        const canPlaceOrder = _cartAvailable() &&
         (vm.cartDisplay.diningOption === ORDER_TYPES.TAKE_OUT || _neededForDelivery() === 0)
         && (_getPlaceOrderIssue() === null);

        return canPlaceOrder;
    }

    function _neededForDelivery() {
        const preDiscountAmount = vm.cartData.cart.check.subtotal + vm.cartData.cart.check.promoCodeDiscount;
        return Math.max(vm.deliveryMinimum - preDiscountAmount, 0);
    }

    function buttonText() {
        if (canPlaceOrder()) {
            return `Checkout - ${$filter('currency')(paymentService.getTotalAmountForDisplay())}`;
        } else if (_cartAvailable() && _shouldEnforceDeliveryMin()) {
            return `Add ${$filter('currency')(_neededForDelivery())} to Meet Minimum`;
        } else {
            return 'Checkout';
        }
    }

    function checkout() {
        googleAnalyticsTrackingService.trackCheckoutAtMenuEvent(cartService.getCartData());

        if(!canPlaceOrder()) {
            blockingCalloutService.show(_getPlaceOrderIssue() || 'Unknown error has occurred. Please try again or contact the restaurant to place your order.');
            return false;
        }

        if(!canPlaceOrder()) return false;

        vm.isLoading = true;
        cartService.configureCart(vm.cartDisplay.diningOption,
            vm.cartDisplay.fulfillmentType,
            vm.cartDisplay.fulfillmentMoment,
            true)
            .then(() => {
                $state.go('checkout');
                cartService.clearCartError();
                vm.isLoading = false;
                cartDisplayService.updateFulfillmentTimeFromCart();

            }, data => {
                if(data.error === OUT_OF_STOCK_ERROR) {
                    cartStatusChannel.changedCart();
                }
                vm.isLoading = false;
            });
    }

    function _shouldEnforceDeliveryMin() {
        return vm.deliveryMinimum > 0 && vm.cartDisplay.diningOption === ORDER_TYPES.DELIVERY;
    }
}
